export const environment = {
  production: false,
  serverUrl: "https://server.dev.terminal.fiara.ge",
  siteUrl: "http://localhost:4201"
};
